import { render } from "./Default2Page.vue?vue&type=template&id=1d846a7c"
import script from "./Default2Page.vue?vue&type=script&lang=js"
export * from "./Default2Page.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__